/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-26 15:36:18
 * @LastEditTime: 2021-01-22 11:43:32
 * @LastEditors: daikeyi
 */
import * as types from './types';
import OWCModule from '@/base/module';
import { doRequest } from '@/http/http';
import { ESVStorage } from 'esvcp-mobile';

const state = {
    currentModule: OWCModule.WorkOrder,
    loadWXConfig: 0,
    wxAuthenticate: 0,
    isDeviceReady: false,
    pageList: [],
    opId: '',
    loginStatus: false, // 登录状态 false未登录
    direction: 'forward', // 页面方向
    cTabIndex: 0, // 当前的tabIndex
    cUserInfo: {
        name: '李焱生',
        company: '易联云计算',
        avatar: 'http://c.hiphotos.baidu.com/image/pic/item/cefc1e178a82b901e004bbc17f8da9773812ef93.jpg'
    }, // 当前用户
    searchInfo: {
        searchFlag: '',
        productName: '',
        searchTypes: '1',
        styleType: '1',
        searchMassage: '请输入商品名称'
    },
    addressBeginId: '-1',
    // 设置商户配置
    merchantInfo: {}
};

const actions = {
    setAddressBeginId({
        commit,
        state
    }, addressBeginId) {
        commit(types.APP_ADDRESS_BEGIN_ID, addressBeginId);
    },
    // 设置merchantInfo
    setMerchantInfo({
        commit,
        state
    }) {
        return new Promise((resolve, reject) => {
            doRequest({
                url: '/merchant/getMerchantInfo',
                params: {},
                before: function () {
                },
                complete: function () {
                }
            },
            (data) => {
                commit(types.APP_MERCHANT_INFO, data.result);
                resolve(data.result);
            }, (data) => {
                reject(data.result);
            });
        });
    },
    // 设置wxAuthenticate请求状态
    setWxAuthenticate({
        commit,
        state
    }, wxAuthenticate) {
        commit(types.APP_WX_AUTHENTICATE, wxAuthenticate);
    },
    // 设置登录状态
    setLoginStatus({
        commit,
        state
    }, loginStatus) {
        commit(types.APP_LOGIN_STATUS, loginStatus);
    },
    // 设置页面的方向
    setDirection({
        commit,
        state
    }, direction) {
        commit(types.APP_PAGE_DIRECTION, direction);
    },
    // 设置当前的index
    setCTabIndex({
        commit,
        state
    }, cTabIndex) {
        commit(types.APP_CTAB_INDEX, cTabIndex);
    },
    // 设置searchInfo
    setSearchInfo({
        commit,
        state
    }, cSearchInfo) {
        commit(types.APP_SEARCH_INFO, cSearchInfo);
    },
    // 设置当前用户
    setCUserInfo({
        commit,
        state
    }, cUserInfo) {
        commit(types.APP_CUSERINFO, cUserInfo);
    },
    setPageList({
        commit,
        state
    }, pageList) {
        commit(types.APP_PAGE_LIST, pageList);
    },
    setIsDeviceReady({
        commit,
        state
    }, isDeviceReady) {
        commit(types.APP_DEVICE_READY, isDeviceReady);
    },
    setCurrentModule ({
        commit,
        state
    }, currentModule) {
        commit(types.APP_CURRENT_MODULE, currentModule);
    },
    setOpId ({
        commit,
        state
    }, opId) {
        commit(types.APP_OP_ID, opId);
    },
    setLoadWXConfig ({
        commit,
        state
    }, loadWXConfig) {
        commit(types.APP_LOAD_WX_CONFIG, loadWXConfig);
    }
};

const getters = {
    addressBeginId: (state) => state.addressBeginId,
    merchantInfo: (state) => state.merchantInfo,
    merchantInfoSwitch: (state) => {
        const arr = ['isOpenRetailStore', 'isSupportCis', 'isSupportInvoice', 'isSupportReturn', 'isReviewRetailStoreAccount', 'synchronizationFlag', 'merchantCode'];
        const merchantInfoSwitch = {};
        for (const k in state.merchantInfo) {
            if (state.merchantInfo.hasOwnProperty(k)) {
                if (arr.indexOf(k) !== -1) {
                    merchantInfoSwitch[k] = state.merchantInfo[k];
                }
            }
        }
        return merchantInfoSwitch;
    },
    wxAuthenticate: (state) => state.wxAuthenticate,
    loginStatus: (state) => state.loginStatus,
    direction: (state) => state.direction,
    cTabIndex: (state) => state.cTabIndex,
    searchInfo: (state) => state.searchInfo,
    cUserInfo: (state) => state.cUserInfo,
    pageList: (state) => state.pageList,
    isDeviceReady: (state) => state.isDeviceReady,
    currentModule: (state) => state.currentModule,
    opId: (state) => state.opId,
    loadWXConfig: (state) => state.loadWXConfig
};

const mutations = {
    [types.APP_ADDRESS_BEGIN_ID](state, addressBeginId) {
        state.addressBeginId = addressBeginId;
    },
    [types.APP_MERCHANT_INFO](state, merchantInfo) {
        console.log('store mutations', merchantInfo);
        state.merchantInfo = merchantInfo;
    },
    [types.APP_WX_AUTHENTICATE](state, wxAuthenticate) {
        state.wxAuthenticate = wxAuthenticate;
    },
    [types.APP_LOGIN_STATUS](state, loginStatus) {
        state.loginStatus = loginStatus;
    },
    [types.APP_PAGE_DIRECTION](state, direction) {
        state.direction = direction;
    },
    [types.APP_CTAB_INDEX](state, cTabIndex) {
        state.cTabIndex = cTabIndex;
    },
    [types.APP_SEARCH_INFO](state, searchInfo) {
        state.searchInfo = searchInfo;
    },
    [types.APP_CUSERINFO](state, cUserInfo) {
        state.cUserInfo = cUserInfo;
    },
    [types.APP_PAGE_LIST](state, pageList) {
        state.pageList = pageList;
    },
    [types.APP_DEVICE_READY](state, isDeviceReady) {
        state.isDeviceReady = isDeviceReady;
    },
    [types.APP_CURRENT_MODULE] (state, currentModule) {
        state.currentModule = currentModule;
    },
    [types.APP_OP_ID] (state, opId) {
        state.opId = opId;
    },
    [types.APP_LOAD_WX_CONFIG] (state, loadWXConfig) {
        state.loadWXConfig = loadWXConfig;
    }
};

export default {
    state,
    actions,
    getters,
    mutations
};
